module.exports = __webpack_public_path__ + "static/media/logo-covid-omics.0f3b2fe0.png";